import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ContactCustomerModal from 'ContactCustomerModal';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import { updatePhaseTask } from 'actionCreators/phase';
import PhaseTask from './phase_task';

export class ContactCustomerPhaseTask extends PhaseTask {
  isDisabled = () => false

  onClick = () => {
    if (this.props.task.status === 'complete') {
      this.toggleStatus();
    } else {
      this.setState({ modalActive: true });
    }
  }

  renderChildren = () =>
    <ContactCustomerModal
      phase={this.props.phase}
      task={this.props.task}
      active={this.state.modalActive}
      completeTask={this.completeTask}
      onClose={this.handleClose}
    />
}

ContactCustomerPhaseTask.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
};

export const contact_customer = connect(() => ({}), { updatePhaseTask })(ContactCustomerPhaseTask);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/contact_customer.jsx